import React from "react";

/**
 * Collective Flow Orbs — animated SVG showing 11 nodes (a football team)
 * connected with neon flow lines that pulse, expressing players operating
 * as one organism. Pure decorative. Used in select sections.
 */
const NODES = [
  // formation roughly 4-3-3
  { x: 50, y: 88 }, // GK
  { x: 18, y: 70 }, { x: 38, y: 70 }, { x: 62, y: 70 }, { x: 82, y: 70 },
  { x: 30, y: 48 }, { x: 50, y: 50 }, { x: 70, y: 48 },
  { x: 22, y: 22 }, { x: 50, y: 18 }, { x: 78, y: 22 },
];

// connections for visual flow (player → next-line passes)
const EDGES = [
  [0, 1], [0, 2], [0, 3], [0, 4],
  [1, 5], [2, 5], [2, 6], [3, 6], [3, 7], [4, 7],
  [5, 8], [5, 9], [6, 9], [7, 9], [7, 10], [6, 10],
  [8, 9], [9, 10],
];

const CollectiveFlowOrbs = ({ className = "", opacity = 0.7 }) => {
  const id = React.useId();
  return (
    <svg
      aria-hidden
      viewBox="0 0 100 100"
      preserveAspectRatio="xMidYMid meet"
      className={`pointer-events-none ${className}`}
      style={{ opacity }}
    >
      <defs>
        <linearGradient id={`flow-${id}`} x1="0" y1="0" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#FF2D5C" />
          <stop offset="50%" stopColor="#FF3DCB" />
          <stop offset="100%" stopColor="#3DBFFF" />
        </linearGradient>
        <radialGradient id={`node-${id}`} cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#ffffff" />
          <stop offset="60%" stopColor="#FF3DCB" />
          <stop offset="100%" stopColor="#FF3DCB" stopOpacity="0" />
        </radialGradient>
        <filter id={`glow-${id}`} x="-100%" y="-100%" width="300%" height="300%">
          <feGaussianBlur stdDeviation="0.6" result="b" />
          <feMerge>
            <feMergeNode in="b" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>

      {/* Edges with animated dash flow */}
      {EDGES.map((e, i) => {
        const a = NODES[e[0]];
        const b = NODES[e[1]];
        return (
          <line
            key={i}
            x1={a.x}
            y1={a.y}
            x2={b.x}
            y2={b.y}
            stroke={`url(#flow-${id})`}
            strokeWidth="0.35"
            strokeOpacity="0.55"
            strokeDasharray="2 3"
            filter={`url(#glow-${id})`}
            style={{
              animation: `eu-flow-dash ${5 + (i % 3)}s linear infinite`,
              animationDelay: `${-i * 0.18}s`,
            }}
          />
        );
      })}

      {/* Nodes (players) */}
      {NODES.map((n, i) => (
        <g
          key={i}
          style={{
            animation: `eu-flow-pulse ${3 + (i % 4) * 0.5}s ease-in-out infinite`,
            animationDelay: `${-i * 0.25}s`,
            transformOrigin: `${n.x}px ${n.y}px`,
          }}
        >
          <circle cx={n.x} cy={n.y} r="2.6" fill={`url(#node-${id})`} />
          <circle cx={n.x} cy={n.y} r="1" fill="#fff" />
        </g>
      ))}
    </svg>
  );
};

export default CollectiveFlowOrbs;
